/**
 * Humanises a raw subsystem / source identifier into a display label.
 *   "AuthService"  -> "Auth Service"
 *   "node_manager" -> "Node Manager"
 *   "HTTPServer"   -> "Http Server"
 */
export function formatSubsystem(raw: string): string {
  const spaced = raw
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
  return spaced
    .split(/[\s_-]+/)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ')
}
